<app-modal>
  <form (ngSubmit)="onSubmit()"
        [formGroup]="formGroup">

    <h2 class="mb-0025">Edit follow-up flag due date for:</h2>
    <h3 class="mb-0100"> {{data.entityName}}</h3>

    <mat-form-field class="col__">
      <mat-label>Due Date (leave blank for none)</mat-label>
      <input matInput
              type="text"
              [matDatepicker]="dueDatePicker"
              autocomplete="off"
              [formControl]="dueDateControl"
              (input)="onDueDateInput($event)"
              name="dueDate" />
      <mat-datepicker-toggle matSuffix
                              [for]="dueDatePicker">
        <mat-icon fontSet="far"
                  fontIcon="fa-calendar"
                  matDatepickerToggleIcon></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #dueDatePicker></mat-datepicker>
    </mat-form-field>

    <button class="btn"
            type="submit"
            [disabled]="!hasChanges || isSaving">
      Save Changes
    </button>
  </form>
</app-modal>
